import { mountConsentUi } from './ui.js';
import type { ConsentUi, ConsentUiOptions } from './ui.js';

export { DEFAULT_TEXTS } from './texts.js';
export { COOKIE_TABLE_ATTRIBUTE, OPEN_ATTRIBUTE } from './ui.js';

export type ConsentUiBrowserOptions = Omit<ConsentUiOptions, 'client'> & {
  readonly client?: ConsentUiOptions['client'];
};

// The script tag build talks to the core's browser global unless told otherwise.
export function mount(options: ConsentUiBrowserOptions = {}): ConsentUi {
  const client =
    options.client ??
    (globalThis as { readonly GoksimaConsent?: ConsentUiOptions['client'] })
      .GoksimaConsent;
  return mountConsentUi({ ...options, client } as ConsentUiOptions);
}
